// Types
import type { TListingFilters, TStoredFilters } from '~/misc/listings/types';

// Utils
import { normalizeRange } from '~/misc/listings/utils/range';
import { stripNullValues } from '~/shared/utils';

/**
 * Strips null values and normalizes range fields from stored/default filters.
 */
const cleanStoredFilters = (stored: Partial<TStoredFilters>): Partial<TListingFilters> => ({
  ...stripNullValues(stored),
  price_range: normalizeRange(stored.price_range),
  bed_range: normalizeRange(stored.bed_range),
});

export { cleanStoredFilters };
